<template>
  <iframe width="1920" :src="src" allow="fullscreen" class="modal__youtube"/>
</template>

<script>
export default {
  name: 'YoutubeModal',
  computed: {
    src() {
      const link = new URL(`https://www.youtube.com/embed/${this.$store.state.app.youtube_id}`)
      link.searchParams.set('playlist', this.$store.state.app.youtube_id)
      link.searchParams.set('autoplay', '1')
      link.searchParams.set('fs', '1')
      link.searchParams.set('mute', '1')
      link.searchParams.set('loop', '1')
      link.searchParams.set('disablekb', '1')

      return link.toString()
    }
  }
}
</script>